import { Typography } from "@mui/material"
import { IStatus } from "../util/interface"
import { createUseStyles } from "react-jss"

const useStyles = createUseStyles({
  statusContainer: {
    display: "flex",
    gap: 2,
    justifyContent: ({ align }: any) => (align ? align : "center"),
  },
  iconContainer: {
    height: 20,
    width: 22,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    background: ({ backgroundColor }: any) => backgroundColor,
  },
})

export const Status = ({ icon, text, backgroundColor, align }: IStatus) => {
  const classes = useStyles({ backgroundColor, align })

  return (
    <div className={classes.statusContainer}>
      <div className={classes.iconContainer}>
        <img src={icon} alt="" />
      </div>
      <Typography variant="statusText">{text}</Typography>
    </div>
  )
}
